/* eslint-disable react/no-unknown-property */
import React from 'react';
import { IconsPropsType } from './icons.config.type';
import tinycolor from 'tinycolor2';

const DecisiveConditionStar: React.FC<IconsPropsType> = ({ style, color, onClick, className, numberText }) => {
  const fontSize = (numberText?.length ?? 0) <= 6 ? 12 : (numberText?.length ?? 0) <= 9 ? 10 : 8;

  return (
    <svg
      style={{ ...style }}
      width="40"
      height="40"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M12 2L14.7553 8.54136L22 9.33333L16.5 14.0515L18.5107 21L12 17.25L5.48929 21L7.5 14.0515L2 9.33333L9.24471 8.54136L12 2Z"
        stroke="black"
        strokeWidth="0.3"
        fill={color}
      />
      {numberText && (
        <text
          x="50%"
          y="53%"
          textAnchor="middle"
          fontSize={2}
          fontWeight="bold"
          fill={tinycolor(color).isLight() ? 'black' : 'white'}
        >
          {numberText}
        </text>
      )}
    </svg>
  );
};

DecisiveConditionStar.defaultProps = {
  style: { width: '40px', height: '40px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default DecisiveConditionStar;
